import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnChanges } from '@angular/core';

@Component({
  selector: 'app-popup-benefit-divider',
  imports: [NgClass],
  template: ` <div [ngClass]="classes"></div> `,
  styles: `
    .vertical {
      border-left: 1px solid;
      height: 100%;
      margin-left: 1em;
      margin-right: 1em;
    }

    .horizontal {
      border-top: 1px solid;
      width: 100%;
      margin-top: 1em;
      margin-bottom: 1em;
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PopupBenefitDividerComponent implements OnChanges {
  @Input() cssClass = '';
  @Input({ required: true }) direction: 'horizontal' | 'vertical';

  classes: string[] = [];

  ngOnChanges(): void {
    this.classes = [this.direction];

    if (this.cssClass) {
      this.classes.push(this.cssClass);
    }
  }
}
